import client from "../Client/HttpClient";
import {ICoursesModel} from "@/interfaces/modules/";
const ApiPath = "Courses";

export default {
    GetCourses:(showPreschool: any) : Promise <ICoursesModel[]> => client.get(`${ApiPath}/GetAll/${showPreschool}`),
    GetAllExcludingPreschool:() : Promise <ICoursesModel[]> => client.get(`${ApiPath}/GetAllExcludingPreschool`),
    GetCoursesbyId: (data: any): Promise <ICoursesModel> => client.get(`${ApiPath}/${data.Id}`), 
    PostCourses: (data: any): Promise<ICoursesModel> => client.post(`${ApiPath}`, data)
  };

  